import { gql } from "@apollo/client";

export const FETCH_FORECAST_CATEGORIES = gql`
  query FETCH_FORECAST_CATEGORIES {
    forecastCategories {
      id
      mode
      displayName
      stockCategory {
        id
        name
      }
      lastSubmission(hasSubmitted: true) {
        id
        submittedAt
        user {
          id
          email
        }
      }
    }
  }
`;

export const FETCH_FCST_OVERVIEW = gql`
  query FETCH_FCST_OVERVIEW($mode: String, $forecastCategoryId: ID) {
    salesGetForecast(mode: $mode, forecastCategoryId: $forecastCategoryId)
    euContainers: containers(zone: "EU") {
      id
      name
      cost
      cbm
    }
    usContainers: containers(zone: "US") {
      id
      name
      cost
      cbm
    }
  }
`;

export const FETCH_PETE_FCST = gql`
  query FETCH_PETE_FCST(
    $userId: String!
    $filePath: String!
    $sheetName: String!
    $returnRows: Boolean
  ) {
    salesPeteForecast(
      userId: $userId
      filePath: $filePath
      sheetName: $sheetName
      returnRows: $returnRows
    )
    salesGetProductsForFcst(mode: "INC") {
      id
      odooId
      name
      number
      version
      countryCodeOfOrigin
      itemsPerSet
    }
  }
`;

export const SAVE_FORECAST_SUBMISSION = gql`
  mutation SAVE_FORECAST_SUBMISSION(
    $company: String!
    $warehouse: String!
    $data: String!
    $forecastCategoryId: ID
  ) {
    salesSaveForecastSubmission(
      company: $company
      warehouse: $warehouse
      data: $data
      forecastCategoryId: $forecastCategoryId
    ) {
      submission {
        id
        company
        warehouse
        data
        createdAt
        updatedAt
        submittedAt
      }
    }
  }
`;

export const SUBMIT_FORECAST = gql`
  mutation SUBMIT_FORECAST($forecastCategoryId: ID!, $data: String!) {
    salesSubmitForecast(forecastCategoryId: $forecastCategoryId, data: $data) {
      submission {
        id
      }
    }
  }
`;
